import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=367c10ee&"
import script from "./Admission.vue?vue&type=script&lang=js&"
export * from "./Admission.vue?vue&type=script&lang=js&"
import style0 from "./Admission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports